<template>
  <div class="quote-section-container">
    <ul
      v-if="!showCarousel"
      class="quote-cards-section"
    >
      <li
        v-for="(quote, i) in quotes"
        :key="i"
        class="quote-card-container"
        @click="quoteSelected(i)"
      >
        <brazil-v-card
          :active="selectedQuote === i"
          :reg-outlined="true"
          :outlined="true"
        >
          <slot v-bind="quote" />
        </brazil-v-card>
      </li>
    </ul>
    <carousel
      v-if="showCarousel"
      :per-page="1.1"
      :navigate-to="selectedQuote"
      pagination-active-color="#f5bf05"
      pagination-color="#9b9b9b"
      class="refi-carousel"
      @page-change="onPageChange"
    >
      <slide
        v-for="(quote, i) in quotes"
        :key="i"
      >
        <brazil-v-card
          :active="selectedQuote === i"
          :raised="selectedQuote === i"
          :reg-outlined="true"
          :outlined="true"
          class="offer-card-slide"
        >
          <slot v-bind="quote" />
        </brazil-v-card>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import BrazilVCard from './BrazilVCard.vue';

export default {
  components: {
    BrazilVCard, Carousel, Slide,
  },
  props: {
    quotes: {
      type:     Array,
      required: true,
    },
    showCarousel: {
      type:    Boolean,
      default: false,
    },
    showButtons: {
      type:    Boolean,
      default: true,
    },
    bus: {
      type:    Object,
      default: null,
    },
  },
  data() {
    return {
      windowWidth:  window.innerWidth,
      defaultQuote: 0,
      activeQuote:  null,
      dialogOpen:   false,
    };
  },
  computed: {
    selectedQuote() {
      return this.activeQuote != null ? this.activeQuote : this.defaultQuote;
    },
  },
  mounted() {
    if (this.bus != null) {
      this.bus.$on('clearSelection', this.clearSelection);
    }
  },
  methods: {
    onPageChange(value) {
      this.activeQuote = value;
      this.$emit('quoteSelected', value);
    },
    clearSelection() {
      this.activeQuote = null;
      this.dialogOpen = false;
    },
    quoteSelected(value) {
      this.activeQuote = value;
      this.$emit('quoteSelected', value);
    },
  },
};
</script>

<style lang="scss" scoped>
  .quote-cards-section {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-left: 0;
  }
  ul.quote-cards-section{
    list-style: none;
  }
  .offer-card-slide {
    margin: 1px 10px 1px 10px;
    cursor: pointer;
  }

  @media screen and (min-width: 700px) {
    .quote-card-container {
      width: 50%;
    }
  }
</style>
